<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                :default-expand-all="false"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户" align="center">
                    <template slot-scope="scope">
                        <div>ID:{{ scope.row.userId }}</div>
                        <div>昵称:{{ scope.row.nickName }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="header" label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.header"
                        :preview-src-list="[scope.row.header]"
                        v-if="scope.row.header"
                        fit="cover"></el-image>
                    </template>
                </el-table-column>
                
               
                <el-table-column prop="path" label="所得税申报截图" align="center">
                    <template slot-scope="scope">
                        <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.path"
                        :preview-src-list="[scope.row.path]"
                        v-if="scope.row.path"
                        fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="income" label="收入" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.income==1">3k以上</span>
                        <span v-if="scope.row.income==2">5k以上</span>
                        <span v-if="scope.row.income==3">8k以上</span>
                        <span v-if="scope.row.income==4">12k以上</span>
                        <span v-if="scope.row.income==5">20k以上</span>
                        <span v-if="scope.row.income==5">50k以上</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lianTaDou" label="认证方式" align="center" width="80">
                    <template slot-scope="scope">
                        {{ scope.row.lianTaDou ? scope.row.lianTaDou + '恋豆' : '免费认证' }}
                    </template>
                </el-table-column>
                <el-table-column prop="renZhenState" label="认证状态/时间" align="center" width="160">
                    <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.renZhenState == 1">认证中</el-tag>
                        <el-tag type="info" v-if="scope.row.renZhenState == 0">未认证</el-tag>
                        <el-tag type="danger" v-if="scope.row.renZhenState == -1">认证失败</el-tag>
                        <el-tag type="success" v-if="scope.row.renZhenState == 2">已认证</el-tag>
                        <div>
                            {{ scope.row.renZhenDate }}
                        </div>
                    </template>
                </el-table-column>
               
                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="isDetailDialogShow(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="查询详情" width="750px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        认证状态
                    </div>
                    <div class="value">
                        <el-radio v-model="doRenZhengData.renZhenState" :label="-1">认证失败</el-radio>
                        <el-radio v-model="doRenZhengData.renZhenState" :label="2">认证成功</el-radio>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        理由
                    </div>
                    <div class="value">
                        <el-input v-model="doRenZhengData.remark" size="small" placeholder="请输入" type="textarea" :rows="5"></el-input>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="renZhenChange">确认编辑</el-button>
                </div>
            </div>
        </el-dialog>
        
        
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
  

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,
            isDetailDialog:false,
            formData:{},
            formDataAdd:{
                "parentId": "",
                "name": "",
                "sort": 0,
                "imgUrl": "",
                "isShow": true,
            },
            doRenZhengData: {
                "id": null,
                "userId": null,
                "renZhenState": 0,
                "remark": "",
                "type": 3
            },
            totalCount:0,
            // tableData:[],
            tableData: [
                
            ],

            conditionData:{
                userId: null,
                phone: "",
                renZhenState: null,
                pageSize: 10,
                page: 1
            },
            queryList:[
                {type: "input",label: "用户ID:",name: "userId"},
                // {type: "input",label: "手机号:",name: "phone"},
                {type: "select",label: "认证状态:",name: "renZhenState",options:[
                    {
                        label:'未认证',
                        value:0
                    },{
                        label:'认证中',
                        value:1
                    },{
                        label:'已认证',
                        value:2
                    },{
                        label:'认证失败',
                        value:-1
                    }
                ]}
            ],
           
           
            
           
        }
    },
    created(){
    },
    mounted(){
        if(this.$route.query.id){
            this.conditionData.snapMsgId = parseFloat(this.$route.query.id)
        }
        this.loadingData();
    },
    methods:{
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.GetIncomeReal(this.conditionData);
            console.log('loadingData');
            console.log(res.data);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            console.log(this.tableData);
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                sendPhone: "",
                toPhone: "",
                sendCity: "",
                toCity: "",
                pageSize: 10,
                page: 1 
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        async isDetailDialogShow(row){
            this.isDetailDialog = true;
            this.doRenZhengData.id = row.id;
            this.doRenZhengData.userId = row.userId
        },
        async renZhenChange(){
            let res = await api.doRenZheng(this.doRenZhengData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
                this.isDetailDialog = false;
                this.loadingData();
                this.doRenZhengData = {
                    "id": null,
                    "userId": null,
                    "renZhenState": 0,
                    "remark": "",
                    "type": 3
                }
            }
        }
        
    }
    
}
</script>

<style lang="scss" scoped>
    .person{
        height: 700px;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        padding-top: 30px;
        font-size: 14px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
   
</style>
